var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.page.type == 'two-column-page')?_c('team-member-page',{attrs:{"page":_vm.page,"lang":_vm.lang}}):_vm._e(),(_vm.page.type == 'big-banner-page')?_c('big-banner-page',{attrs:{"page":_vm.page,"lang":_vm.lang}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }